import axios from 'axios';
import store from '../redux/store';
import { User } from '../interfaces/api/user';
import { fetchDevicesThunk } from '../redux/slicers/deviceSlice';
import { fetchTagsThunk } from '../redux/slicers/tagSlice';
import { fetchUserThunk } from '../redux/slicers/authenticationSlice';
import Cookies from 'js-cookie';
import { fetchDeviceTypesThunk } from '../redux/slicers/deviceTypeSlice';
import { DeviceType } from '../interfaces/api/deviceType';
import { fetchOrganizationsThunk } from '../redux/slicers/organizationSlice';
import { fetchBuildingsThunk } from '../redux/slicers/buildingSlice';
import { Device } from '../interfaces/api/device';

async function initializeUser(
	withPermission: boolean = false
): Promise<{ user: User; permissions?: number[] } | undefined> {
	const token = Cookies.get('Token');
	if (token) {
		const parsedToken = JSON.parse(token);
		axios.defaults.headers.common['Authorization'] = `Token ${parsedToken.token}`;
		const user = await store.dispatch(fetchUserThunk({ params: { fields: 'id,name' } }));
		if (withPermission) {
			return {
				user: user.payload as User,
				permissions: store.getState().authentication.permissions as number[],
			};
		}
		return {
			user: user.payload as User,
		};
	}
	return undefined;
}

async function initializeData(user: User, withToken: boolean): Promise<boolean> {
	try {
		const deviceTypeResult = await store.dispatch(
			fetchDeviceTypesThunk({ params: { search: 'Powermeter', fields: 'id,name' } })
		);
		if (
			deviceTypeResult.meta.requestStatus === 'fulfilled' &&
			(deviceTypeResult.payload as DeviceType[])[0]
		) {
			const [organizationResult, buildingResult, deviceResult] = await Promise.allSettled([
				store.dispatch(
					fetchOrganizationsThunk({
						params: {
							fields: 'id,name',
						},
					})
				),
				store.dispatch(
					fetchBuildingsThunk({
						params: {
							fields: 'id,name,organization',
						},
					})
				),
				store.dispatch(
					fetchDevicesThunk({
						params: {
							deviceTypes: (deviceTypeResult.payload as DeviceType[]).map((deviceType) =>
								String(deviceType.id)
							),
							fields: 'id,name,organization,building',
						},
					})
				),
			]);
			const selectedDevice: Device | undefined = store.getState().device.selectedDevice;
			if (
				organizationResult.status === 'rejected' ||
				buildingResult.status === 'rejected' ||
				deviceResult.status === 'rejected' ||
				!selectedDevice
			) {
				return false;
			}
			await store.dispatch(
				fetchTagsThunk({
					params: {
						device: String(selectedDevice.id),
						fields: 'id,name,active,description,modality_type,device,type',
					},
				})
			);
		}
		return true;
	} catch (e) {
		return false;
	}
}

const initialization = {
	initializeUser,
	initializeData,
};

export default initialization;
